import type { RouteRecordRaw } from 'vue-router'
import { routeAlias, routeNames, routePaths } from '@/router/router-constants'

export const userRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.users,
    name: routeNames.users,
    component: () => import('@/pages/users/UsersView.vue'),
    meta: { permission: 'users.read.all', icon: 'pi pi-users', labelKey: 'users' },
  },
  {
    path: routePaths.userCreation,
    name: routeNames.userCreation,
    component: () => import('@/pages/users/AddEditUserView.vue'),
    meta: {
      permission: 'users.write.all',
      labelKey: 'new_m',
      rootRouteName: routeNames.users,
    },
  },
  {
    path: routePaths.userEdit,
    name: routeNames.userEdit,
    alias: routeAlias.userEdit,
    component: () => import('@/pages/users/AddEditUserView.vue'),
    meta: {
      permission: 'users.write.all',
      labelKey: 'edit',
      rootRouteName: routeNames.users,
    },
  },
]
